import SignUpRepository from '@src/repositories/SignUpRepository';

class SignUpService {
  constructor() {
    this.signUpRepository = new SignUpRepository();
  }

  async updateSignUp(data) {
    return await this.signUpRepository.updateSignUp(data);
  }
}

export default SignUpService;
